import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'search-page.browser-extension-banner.title',
		defaultMessage: 'Use Rovo wherever you are',
		description: 'Title for the browser extension banner promoting Rovo',
	},
	linkText: {
		id: 'search-page.browser-extension-banner.link-text',
		defaultMessage: 'Get the browser extension',
		description: 'Link text to download the browser extension',
	},
	closeButtonLabel: {
		id: 'search-page.browser-extension-banner.close-button-label',
		defaultMessage: 'Close browser extension banner',
		description: 'Accessibility label for the close button',
	},
});
